module.exports = "build/assets/iPhoneXSpeaker.abb9d2a5.png";